module.exports = __webpack_public_path__ + "img/video-23.616e483c.png";